import React, { createContext, useContext, useState, useEffect } from "react";

const PolicyContext = createContext();

export const PolicyProvider = ({ children }) => {
    const [policies, setPolicies] = useState([]);

    // Load from sessionStorage when app starts
    useEffect(() => {
        const storedPolicies = sessionStorage.getItem("userPolicies");
        if (storedPolicies) {
            setPolicies(JSON.parse(storedPolicies));
        }
    }, []);

    // Save to sessionStorage whenever policies change
    const updatePolicies = (newPolicies) => {
        setPolicies(newPolicies || []);
        sessionStorage.setItem("userPolicies", JSON.stringify(newPolicies || []));
    };

    return (
        <PolicyContext.Provider value={{ policies, updatePolicies }}>
            {children}
        </PolicyContext.Provider>
    );
};

export const usePolicy = () => useContext(PolicyContext);
